import { memo } from 'react';
import { Grid } from '@mui/material';
import { FormTextField, FormSelectAutocompleteField } from '@dfl/mui-react-common';
import { IProviderField, PROVIDER_DATA_TYPE_ENUM } from 'modules/inventory/settings/provider-field/interfaces/IProviderField';
import { FormCustomSwitchField } from 'modules/common/components/IphoneSwitchField';

type DynamicFieldFormFieldProps = {
  field: IProviderField;
};

const DynamicFieldFormField = ({ field }: DynamicFieldFormFieldProps) => {
  const fieldName = `dynamicData.${field.label}`;

  if (field.dataType === PROVIDER_DATA_TYPE_ENUM.BOOLEAN) {
    return (
      <Grid item xs={12}>
        <FormCustomSwitchField name={fieldName} label={field.label} />
      </Grid>
    );
  }

  if (field.fixedValues?.length) {
    const options = field.fixedValues.map(String);
    const isArray = field.dataType === PROVIDER_DATA_TYPE_ENUM.ARRAY;
    return (
      <Grid item xs={12}>
        <FormSelectAutocompleteField
          name={fieldName}
          label={field.label}
          required={field.required}
          options={options}
          multiple={isArray}
          isOptionEqualToValue={(opt: string, val: any) => opt === String(val)}
          getOptionLabel={(opt: string) => String(opt)}
          fullWidth
        />
      </Grid>
    );
  }

  if (field.dataType === PROVIDER_DATA_TYPE_ENUM.ARRAY) {
    return (
      <Grid item xs={12}>
        <FormSelectAutocompleteField
          name={fieldName}
          label={field.label}
          required={field.required}
          multiple
          freeSolo
          options={[]}
          isOptionEqualToValue={(opt: string, val: string) => opt === val}
          getOptionLabel={(opt: string) => String(opt)}
          fullWidth
        />
      </Grid>
    );
  }

  return (
    <Grid item xs={12}>
      <FormTextField
        fullWidth
        name={fieldName}
        label={field.label}
        required={field.required}
        type={field.dataType === PROVIDER_DATA_TYPE_ENUM.NUMBER ? 'number' : 'text'}
      />
    </Grid>
  );
};

export default memo(DynamicFieldFormField);
